import React from 'react'

const Download = () => {
  return (
    <div>
      <h1 className='py-5 text-center'>Download</h1>
    </div>
  )
}

export default Download
